import type { NavigationContainerRefWithCurrent } from '@react-navigation/native';
import type { RootStackParamList } from './RootNavigator';

/**
 * Navigation impérative vers Réglages > Infos perso (depuis le pop-up de complétion du profil).
 *
 * `initial: false` est essentiel : sans lui, le ProfileNavigator (onglet Profil, monté paresseusement)
 * s'initialise avec PersonalInfo comme UNIQUE route → le retour arrière n'a rien à dépiler et remonte
 * au TabNavigator (backBehavior 'firstRoute' → Accueil). Avec `initial: false`, la pile devient
 * [Profile, PersonalInfo] → le retour reste dans l'onglet Profil.
 */
export function goToProfilePersonalInfo(
  ref: NavigationContainerRefWithCurrent<RootStackParamList>,
): void {
  if (!ref.isReady()) return;
  ref.navigate('Main', { screen: 'Profile', params: { screen: 'PersonalInfo', initial: false } });
}
